<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getNotificacao"
  />
</template>

<script>
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedNotificacaoData } from '../notificacaoService';
import { useToast } from 'vue-toastification';
import { toDate } from '@/modules/core/utils/formats';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';

export default {
  components: { TabelaOSD },
  data: () => ({
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('titulo')),
          field: 'titulo',
        }, {
          label: computed((_) => i18n.global.t('mensagemResumida')),
          field: 'mensagem',
        }, {
          label: computed((_) => i18n.global.t('mensagemCompleta')),
          field: 'data',
        }, {
          label: computed((_) => i18n.global.t('status')),
          field: 'status',
          sortable: false,
        }, {
          label: computed((_) => i18n.global.t('dataHoraCriacao')),
          field: 'criadoEm',
          tdClass: 'text-break',
          formatFn: toDate,
        },
      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
      ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
      `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'criadoEm', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'criadoEm',
      order: 'desc',
    },
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label); },
  },
  mounted() {
    this.getNotificacao();
  },
  methods: {
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getNotificacao();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getNotificacao();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getNotificacao();
    },
    async getNotificacao() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedNotificacaoData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(ref(computed((_) => i18n.global.t('erroAoObterNotificacoes'))));
      }
      this.table.isLoading = false;
    },
  },
};

</script>
